import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { toastInfo } from '../../utils/toast';

type PreventAction = {
  btnText: string;
  onAction: () => void;
};

export const usePreventBack = (block: boolean, preventMessage: string, action?: PreventAction) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => block && currentLocation.pathname !== nextLocation.pathname,
  );

  useEffect(() => {
    if (blocker.state === 'blocked') {
      const continueAction = () => {
        blocker.proceed(); // Allow navigation
      };

      toastInfo({
        content: preventMessage,
        ...(action && {
          btnText: action.btnText,
          onAction: () => {
            action.onAction?.();
            continueAction();
          },
        }),
      });
    }
  }, [blocker]);
};
